/** 信用卡號字串每四個數字插入-號
 * @param {String} data 信用卡號碼
*/
export const formatCreditCardNo = (data) => {
    const list = [...data];
    for (let k = 3; k > 0; k--) {
        list.splice(4 * k, 0, '-');
    }
    return list.join('');
};
